<template>
    <v-navigation-drawer
            absolute
            temporary
            right
            v-bind:value="value"
            v-on:input="$emit('input', $event)"
    >
        <template v-slot:prepend>
            <v-list-item two-line>
                <v-list-item-avatar>
                    <img :src="currentChatIcon">
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{currentChat.title}}</v-list-item-title>
                    <v-list-item-subtitle>{{currentChat.description}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </template>

        <v-divider></v-divider>

        <v-list dense>
<!--            <v-list-item-->
<!--            >-->
<!--                <v-list-item-content></v-list-item-content>-->
<!--                <v-list-item-action>-->
<!--                    <v-btn-->
<!--                            text-->
<!--                            x-small-->
<!--                            @click="addToChat()"-->
<!--                    >-->
<!--                        Добавить-->
<!--                    </v-btn>-->
<!--                </v-list-item-action>-->
<!--            </v-list-item>-->
            <v-list-item
                    v-for="item in currentChat.attendees"
                    :key="'attendees_' + item.username"
            >
<!--                <v-list-item-avatar v-if="item.image">-->
<!--                    <v-img :src="item.image"></v-img>-->
<!--                </v-list-item-avatar>-->
                <v-list-item-content>
                    <v-list-item-title>{{ item.displayName }}</v-list-item-title>
                    <v-list-item-subtitle><a :href="'tel:+' + item.phone">{{ '+' + item.phone }}</a></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="item.isHost">
                    <v-badge
                            color="error"
                            inline
                            content="Админ"
                    >
                    </v-badge>
                </v-list-item-action>
<!--                <v-list-item-action v-if="item.username === currentUser || isChatAdmin">-->
<!--                    <v-menu offset-y>-->
<!--                        <template v-slot:activator="{ on, attrs }">-->
<!--                            <v-btn-->
<!--                                    icon-->
<!--                                    small-->
<!--                                    v-bind="attrs"-->
<!--                                    v-on="on"-->
<!--                            >-->
<!--                                <v-icon>mdi-dots-vertical</v-icon>-->
<!--                            </v-btn>-->
<!--                        </template>-->
<!--                        <v-list>-->
<!--                            <v-list-item-->
<!--                                    @click="leaveChat(item.username)"-->
<!--                            >-->
<!--                                <v-list-item-title>Выйти из чата</v-list-item-title>-->
<!--                            </v-list-item>-->
<!--                        </v-list>-->
<!--                    </v-menu>-->
<!--                </v-list-item-action>-->
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: "ChatInfoPanel",
        props:{
            value: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            currentChat() {
                return this.$store.getters.currentChat
            },
            currentChatIcon(){
                return this.currentChat.chatGroup?.image
            },
            currentUser() {
                return this.$store.getters.user
            },
            isChatAdmin() {
                if (this.currentChat) {
                    let admin = this.currentChat.attendees.find(function (item) {
                        return item.isHost
                    })

                    if (admin) {
                        return admin === this.currentUser
                    }
                    return false
                }
                return false
            },
        },
        methods: {
            addToChat() {
                alert('Скоро будет')
            },
            leaveChat(userName) {
                alert('Скоро будет ' + userName)
            },
        }
    }
</script>

<style scoped>

</style>